// src/lib/api.js
import axios from "axios";
import {
  getAccessToken,
  getRefreshToken,
  setAccessToken,
  clearTokens,
} from "./auth";

// hostname του frontend όπως το βλέπει ο browser 
const host = window.location.hostname;

/**
 * Τοπικό dev (τρέχεις από το laptop σου):
 *   frontend: http://localhost:3000
 *   backend:  http://127.0.0.1:8000
 *
 * Server (112), χρήστες μπαίνουν π.χ. στο:
 *   http://195.251.117.112:3000  (ή 80)
 *   backend:  http://195.251.117.112:8000
 */
const LOCAL_API = "http://localhost:8000/api";

// const SERVER_API = "http://195.251.117.100:8000/api";
// const SERVER_API = "http://141.95.41.233/api";
const SERVER_API = "https://seeds-prima.cloud/api";

export const API_BASE =
  host === "localhost" || host === "127.0.0.1"
    ? LOCAL_API // όταν ανοίγεις από το δικό σου laptop
    : SERVER_API; // όταν ανοίγεις τη σελίδα του server (112) από οπουδήποτε

const api = axios.create({ baseURL: API_BASE });

// Βάζουμε Authorization header
api.interceptors.request.use((config) => {
  const token = getAccessToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// --- Auto refresh on 401 ---
let isRefreshing = false;
let pendingRequests = [];

function subscribeTokenRefresh(cb) {
  pendingRequests.push(cb);
}
function onRefreshed(newAccess) {
  pendingRequests.forEach((cb) => cb(newAccess));
  pendingRequests = [];
}

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;

    if (error?.response?.status !== 401 || original?._retry) {
      return Promise.reject(error);
    }

    const refresh = getRefreshToken();
    if (!refresh) {
      clearTokens();
      return Promise.reject(error);
    }

    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        subscribeTokenRefresh((newAccess) => {
          original.headers.Authorization = `Bearer ${newAccess}`;
          resolve(api(original));
        });
      });
    }

    original._retry = true;
    isRefreshing = true;

    try {
      const resp = await axios.post(`${API_BASE}/token/refresh/`, { refresh });
      const newAccess = resp?.data?.access;
      if (!newAccess) throw new Error("No access in refresh response");

      setAccessToken(newAccess);
      isRefreshing = false;
      onRefreshed(newAccess);

      original.headers.Authorization = `Bearer ${newAccess}`;
      return api(original);
    } catch (e) {
      isRefreshing = false;
      pendingRequests = [];
      clearTokens();
      return Promise.reject(e);
    }
  },
);

export default api;
